import { useEffect, useState } from 'react';
import { localInputToIso } from '../lib/events';
import { addDays, formatDue } from '../lib/format';
import { toLocalInput } from './device-history';
import { Button, cn, Field, Input } from './ui';

/** 5 PM on a day some days from now, in the viewer's time zone. */
const afternoon = (days: number) => {
  const day = addDays(days);
  return toLocalInput(new Date(day.getFullYear(), day.getMonth(), day.getDate(), 17, 0));
};

const QUICK_PICKS = [
  { label: 'Today 5 PM', days: 0 },
  { label: 'Tomorrow 5 PM', days: 1 },
  { label: 'In a week', days: 7 },
];

/** When a work order needs to be done by, a day and time, saved when the technician confirms it. */
export function DueAtField({ dueAt, overdue, saving, onSave }: { dueAt: string | null; overdue: boolean; saving: boolean; onSave: (dueAt: string | null) => void }) {
  const current = dueAt ? toLocalInput(dueAt) : '';
  const [draft, setDraft] = useState(current);
  useEffect(() => setDraft(current), [current]);
  const changed = draft !== current;

  return (
    <Field
      as="div"
      label="Due"
      hint={changed ? (draft ? `Due ${formatDue(localInputToIso(draft))}` : 'No due date') : overdue ? 'This work is overdue.' : dueAt ? undefined : 'Optional - when the work needs to be done by'}
    >
      <Input
        type="datetime-local"
        aria-label="Due"
        value={draft}
        onChange={(event) => setDraft(event.target.value)}
        className={cn(overdue && !changed && 'border-red-300 text-red-700')}
      />
      <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1">
        {changed ? (
          <>
            <Button size="sm" loading={saving} onClick={() => onSave(localInputToIso(draft))}>
              {draft ? 'Save due date' : 'Clear due date'}
            </Button>
            <Button size="sm" variant="ghost" disabled={saving} onClick={() => setDraft(current)}>
              Cancel
            </Button>
          </>
        ) : (
          <>
            {QUICK_PICKS.map((pick) => (
              <button key={pick.label} type="button" onClick={() => setDraft(afternoon(pick.days))} className="text-xs font-medium text-brand-700 hover:underline">
                {pick.label}
              </button>
            ))}
            {dueAt && (
              <button type="button" disabled={saving} onClick={() => onSave(null)} className="text-xs font-medium text-slate-500 hover:text-red-700 hover:underline">
                Clear
              </button>
            )}
          </>
        )}
      </div>
    </Field>
  );
}
